import React from 'react';
import './style.css'
import { Link } from 'react-router-dom';
import ChangeLang from '../../../components/changeLang'
import QRCode from "react-qr-code";

const Index = ({ showBack = true, showImageTop = false, showsocial=true,children, showLogo=true, showFooter=true, setShowListProduct, setShowSpecials, goHome }) => {
   
    const [showModal, setShowModal] = React.useState(false);
  const [showModalPincode, setShowModalPincode] = React.useState(false);
  const [secret, setScret] = React.useState("");


  const validScret = () => {

    if (secret === '') {
      alert('Debe ingresar el pin')
    }

    if (secret === "2355") {
       window.location.reload();
    } else {
       alert('Code invalid')
    }
    
  }
  

  const handleButtonClick = () => {
    if (setShowListProduct) {
      setShowListProduct(false); 
    }
   };
  
    return (
      <div className='backgroundlayout' style={{
        flex: 1,
        backgroundSize: 'cover',
        width: '100%',
        height: '100vh',
      
        background: '#000'
      }}>

        {showImageTop && <img
           onContextMenu={(e) => e.preventDefault()}
            src={require('./assets/imagetop.png')}
            style={{
              width: '80%',
              height: 200,
              resizeMode: 'contain',
              position: 'absolute',
              top: 0,
              left: 0,
               pointerEvents: 'none',
              zIndex: 999
            }}
          />}
        
        <div>
          {/*<button onClick={()=>setOpenNav(!openNav)} style={{...styles.iconMenuMobile, ...iconMenu}}>
            <Menu />
          </button>*/}
          

          <div className='contentChild' >

            <div className='nav-menu-bar' style={{
              marginTop: -4 ,
              width: '100%',
              position: 'relative'
            
            }}>
               
              {showLogo &&
              <div style={{
                background: '#000',
                paddingTop: 20,
                paddingBottom: 20,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            
                }}>
                  
                  <div style={{ display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',}}>
                     {showBack && (
                        <div
                            onClick={()=>handleButtonClick()}
                                style={{
                                  width: 140,
                                  height: 52,
                                  display: 'flex',
                                  textAlign: 'center',
                                  alignItems: 'center',
                                  justifyContent: "center",
                                  cursor: 'pointer',
                                  marginLeft: 35,
                                  zIndex: 999,
                                  borderRadius: 999,
                                  border: '4px solid #FEBA29',
                                  background: 'transparent',
                                  color: '#FEBA29',
                                  fontSize: 18,
                                  fontWeight: 800,
                                  textTransform: 'uppercase',
                                  letterSpacing: 1
                            }}>
                              GO BACK
                          </div>
                    )}
                    
                    {!showFooter &&
                     <div
                        onClick={() => {
                          if (goHome) {
                            goHome()
                          }
                        }}
                            style={{
                              width: 140,
                              height: 52,
                              display: 'flex',
                              textAlign: 'center',
                              alignItems: 'center',
                              justifyContent: "center",
                              cursor: 'pointer',
                              marginLeft: 35,
                              zIndex: 999,
                              borderRadius: 999,
                              border: '4px solid #FEBA29',
                              background: 'transparent',
                              color: '#FEBA29',
                              fontSize: 18,
                              fontWeight: 800,
                              textTransform: 'uppercase',
                              letterSpacing: 1
                        }}>
                          Home
                      </div>
                  }


                    {!showFooter &&
                      <div
                         // onClick={()=>setShowSpecials(true)}
                              style={{
                                width: 140,
                                height: 52,
                                display: 'flex',
                                textAlign: 'center',
                                alignItems: 'center',
                                justifyContent: "center",
                                cursor: 'pointer',
                                marginLeft: 35,
                                zIndex: 999,
                                borderRadius: 999,
                                border: '4px solid #FEBA29',
                                background: 'transparent',
                                color: '#FEBA29',
                                fontSize: 18,
                                fontWeight: 800,
                                textTransform: 'uppercase',
                                letterSpacing: 1
                          }}>
                            Specials
                        </div>
                    }

                  </div>
                  
                  <div style={{width: '35%',
                      alignItems: 'center',}}   >
                    {showsocial &&
                      
                      <div style={{
                      
                        display: 'flex',
                          alignItems: 'center',
                              position: 'relative',
                              zIndex: 999,
                              justifyContent: 'end',}}>
                      {/* <div onClick={() => setShowModal('#')} target='_blank'>
                        
                        <img
                           onContextMenu={(e) => e.preventDefault()}
                        style={{
                          width: 50,
                          pointerEvents: 'none',
                            height: 50,
                          marginInline: 10,
                            objectFit: 'contain',
                        
                      }}
                      src={require('./assets/instagram.png')}
                      alt="Logo"
                      /> 
                      </div>

                      <div target='_blank' onClick={()=>setShowModal('#')}> 
                        <img
                           onContextMenu={(e) => e.preventDefault()}
                          style={{
                              width: 42,
                            height: 42,
                                 pointerEvents: 'none',
                            marginInline: 10,
                                 objectFit: 'contain',
                        }}
                          src={require('./assets/facebook.png')}
                          alt="Logo"
                        /> 
                        </div> */}
                        
                        <ChangeLang />
{/* 
                      <div target='_blank' onClick={()=>setShowModal('https://stanciaperuvianfusion.com/?fbclid=PAZXh0bgNhZW0CMTEAAabcJIytXY618p9SWTbgSUCDqZjeqqwDe6N-mVtvD2e3OsRHHxJ4b-C03sg_aem_ySjBYnYb0DeoIbZGrDsMbQ')}> 
                        <img
                          onContextMenu={(e) => e.preventDefault()}
                          style={{
                              width: 30,
                            height: 30,
                                 pointerEvents: 'none',
                                marginInline: 10
                        }}
                          src={require('./assets/web.png')}
                          alt="Logo"
                        /> 
                      </div> */}
                            
                  
                    <div>
                    
                    </div>
                      </div>}
                  </div>

                 
              </div>
              }
              


            

            </div>
            {children}

            
            {showFooter &&
            <div
            style={{
              position: 'absolute',
              bottom: 0,
                alignSelf: 'center',
              
            }}>
            <div
              style={{
                paddingHorizontal: 40,
                paddingVertical: 15,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                  marginTop: 5,
                gap: 20,
                width: '100%',
              }}>
              <div

                    onClick={() => {
                      handleButtonClick()
                      console.log({goHome})
                      if (goHome) {
                        goHome()
                      }
                  }}
                style={{
                  width: 210,
                  height: 70,
                  borderRadius: 999,
                    marginHorizontal: 10,
                  display: 'flex',
                  justifyContent: 'center',
                  paddingHorizontal: 20,
                  alignItems: 'center',
                  flexDirection: 'row',
                  cursor: 'pointer',
                  border: '4px solid #FEBA29',
                  background: 'transparent',
                  color: '#FEBA29',
                  fontSize: 22,
                  fontWeight: 800,
                  textTransform: 'uppercase',
                  letterSpacing: 1
                  }}>
                  Home
              </div>

              <div
                    onClick={() => {
                      // if (setShowSpecials) {
                      //   setShowSpecials(true)
                      // }
                }}
                style={{
                  width: 210,
                  height: 70,
                  borderRadius: 999,
                  marginHorizontal: 10,
                  justifyContent: 'center',
                    paddingHorizontal: 20,
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'row',
                  cursor: 'pointer',
                  border: '4px solid #FEBA29',
                  background: 'transparent',
                  color: '#FEBA29',
                  fontSize: 22,
                  fontWeight: 800,
                  textTransform: 'uppercase',
                  letterSpacing: 1
                  }}>
                  Specials
                
              </div>
            </div>
            <div
              style={{
                zIndex: 100,
                flexDirection: 'row',
                justifyContent: 'space-around',
                paddingHorizontal: 20,
                paddingVertical: 5,
                  alignItems: 'center',
                marginTop: 20,
              }}>
                  <div
                 
                style={{flexDirection: 'row', alignItems: 'center'}}>
                <p
                  style={{
                      color: '#000',
                      fontWeight: '300',
                      textAlign: 'center',
                        fontSize: 12,
                        width: '90%',
                      margin: '0 auto'
                    }}>
                  For your convenience, a 18% gratuity will be added to your
                  bill. A 20 % gratuity to parties of 8 or more. Para su
                  conveniencia, el 18% de servicio será agregado a su cuenta.
                  Thank you/Gracias V1.2
                </p>
              </div>
            </div>
          </div>
            }
            
            


            {showModalPincode &&
              <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                
                <div style={{ position: 'absolute',background: '#fff', width: 500, height: 300, borderRadius: 30, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column" }}>
                  <img
                      onClick={()=>setShowModalPincode(false)}
                    style={{
                      position: 'absolute',
                      top: -10,
                      
                                width: 40,
                                  height: 40,
                                  marginInline: 10,
                                  objectFit: 'contain',
                                  position: 'absolute',
                                  right: -10,
                                  zIndex: 9999
                              
                            }}
                      src={require('./assets/close.png')}
                      alt="Logo"
                  /> 
                  <h4 style={{ color: '#FEBA29', fontSize: 40, fontWeight: 'bold', margin: 20 }}>PIN</h4>
                  <input type='number' style={{ width: 300, height: 40 }} onChange={(e) => {
                    setScret(e.target.value)
                  }} />
                  <br /><br />
                  
                  <div style={{display: 'flex', gap: 20}}>
                    <div onClick={() => setShowModalPincode(false)} style={{background: '#313139', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7}}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>atras</p>
                    </div>
                    <div onClick={()=>validScret()} style={{ background: '#313139', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7 }}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>Enviar</p>
                  </div>
                </div>
                </div>
              </div>
            }

            <div onClick={() => setShowModalPincode(true)} style={{
               position: 'absolute',
                            bottom: -1,
                            right: 0,
              zIndex: 9999,
                            backgroundColor: '#000',
            }}>
            <img
                
                        style={{
                          width: 40,
                            height: 40,
                            marginInline: 10,
                            objectFit: 'contain',
                           
                        
                      }}
                src={require('./assets/pincode.png')}
                alt="Logo"
            /> 
            </div>
            
            

            
            {showModal &&  <div onClick={()=>setShowModal(false)} style={{position: 'absolute', top: 0, bottom: 0, left: 0,width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999}}>
              <QRCode
              size={256}
              style={{ height: 400,  width: 400 }}
              value={showModal}
              divBox={`0 0 256 256`}
            />
            </div>}
           
          </div>
        </div>
      </div>
     
    );
  };

export default Index;